<template>
  <DeviceConditionnalView class="h-full w-full">
    <template #mobile>
      <div class="block md:hidden h-full w-full">
        <slot></slot>
      </div>
    </template>
    <template #desktop>
      <div
        class="relative min-h-screen hidden md:flex items-center justify-center overflow-hidden"
        style="
          background: radial-gradient(at bottom right, #ffcb9b, #ff7d0c 50%);
        "
      >
        <!-- Décorations de fond -->
        <div class="absolute inset-0 opacity-20">
          <div
            class="absolute -top-32 -left-32 w-96 h-96 bg-white/30 rounded-full blur-3xl"
          ></div>
          <div
            class="absolute bottom-0 right-0 w-[30rem] h-[30rem] bg-blue-900/30 rounded-full blur-3xl"
          ></div>
        </div>

        <!-- Conteneur principal -->
        <div
          class="relative z-10 flex flex-col items-center justify-center text-center p-10 rounded-3xl liquidGlassCard max-w-lg"
        >
          <!-- QR Code -->
          <div class="mb-8">
            <img
              v-if="qrCodeDataUrl"
              :src="qrCodeDataUrl"
              alt="QR Code"
              class="w-52 h-52 p-3 bg-white rounded-2xl shadow-lg border border-gray-200"
            />
            <div
              v-else
              class="w-52 h-52 bg-white/40 animate-pulse rounded-2xl border border-white/30"
            ></div>
          </div>

          <!-- Titre -->
          <h2 class="text-3xl font-bold title-color mb-3 drop-shadow-md">
            Accédez à notre plateforme sur mobile
          </h2>

          <!-- Description -->
          <p class="text-base leading-relaxed max-w-sm mb-6">
            Cette plateforme est optimisée pour les appareils mobiles. Scannez
            le QR code ci-dessous avec votre téléphone pour continuer.
          </p>

          <!-- Lien -->
          <div
            class="flex items-center gap-2 px-4 py-2 rounded-lg bg-white/20 text-sm font-mono border border-white/10"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="w-4 h-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8m-18 8h18"
              />
            </svg>
            <span>{{ windowOrigin }}</span>
          </div>
        </div>
      </div>
    </template>
  </DeviceConditionnalView>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import QRCode from 'qrcode'
import DeviceConditionnalView from '@/presentation/components/utils/DeviceConditionnalView.vue'

const qrCodeDataUrl = ref(null)
const windowOrigin = window.location.origin

onMounted(async () => {
  try {
    qrCodeDataUrl.value = await QRCode.toDataURL(windowOrigin, {
      width: 300,
      margin: 2,
      color: {
        dark: '#000000',
        light: '#ffffff',
      },
    })
  } catch (err) {
    console.error('Erreur lors de la génération du QR code:', err)
  }
})
</script>

<style>
html,
body {
  /* overscroll-behavior-y: none; */
  height: 100svh !important;
  max-height: 100svh !important;
  overflow-x: hidden;
  position: relative;
  background-color: #f5f5f7;
  /* background-color: white; */
}

* {
  /* transition-duration: 0.2s; */
  scroll-behavior: smooth;
}
</style>
